import { bridge } from '@sloyd/viewer';
import { delay } from 'shared-base';
import { randomize } from '../extra/extra.utils';
import { generatorToModel } from './models';

let options: any = {},
  isRunning = false,
  currentGenerrator: IGenerator;

export const prepareTour = (
  palettes: IPalettes,
  stepDuration: number = 1000,
  steps: number = 5
) => {
  options.palettes = palettes;
  options.stepDuration = stepDuration;
  options.steps = steps;
};

export const loadGenerator = async (instanceid: string) => {
  if (!currentGenerrator) return;
  const model: any = generatorToModel(currentGenerrator, options.palettes) as IModel;
  bridge.replaceModel(instanceid, model);
  await delay(50);
};

export const changeGenerator = (generator: IGenerator) => {
  currentGenerrator = generator;
};

export const runTourSingle = async (instanceid: string, onStart?: () => void) => {
  try {
    isRunning = true;

    await loadGenerator(instanceid);

    await delay(800);

    if (onStart) {
      bridge.cameraFocus(instanceid);

      onStart();
    }

    const total = options.stepDuration * options.steps;
    // spin(instanceid, total / 1000);

    await delay(options.stepDuration);

    for (let i = 0; i < options.steps; i++) {
      if (!isRunning) return;
      const values = randomize(currentGenerrator.parameters);
      bridge.patchValuesModel(instanceid, values);
      await delay(50);
      bridge.cameraFocus(instanceid);
      await delay(options.stepDuration);
    }
  } catch (e) {}
};

export const runTourMulti = async (instanceid: string, generators: IGenerator[]) => {
  for (const generator of generators) {
    if (!isRunning) return;
    await runTourSingle(instanceid);
  }
};

export const stopTour = () => {
  isRunning = false;
};

export const tour = {
  prepare: prepareTour,
  runSingle: runTourSingle,
  runMulti: runTourMulti,
  stop: stopTour,
  change: loadGenerator,
};
